// Thin wrapper around window.gtag for GA4 custom events.
//
// Consent-gating contract:
//   GA4 is only loaded by public/index.html *after* the user accepts cookies
//   (localStorage['bragsheet_cookie_consent'] === 'accepted'). When consent is
//   not granted, window.gtag is undefined and every call here becomes a no-op.
//   Do NOT force-load gtag from this module — the user's consent choice is the
//   single source of truth for whether GA4 ever runs.
//
// Usage:
//   import { trackEvent } from '../utils/analytics';
//   trackEvent('signup_completed', { method: 'email', grad_year: 2026 });
//
// Note: this file uses both `module.exports` (so Jest's plain `require`
// resolves the named export) and a default `export` shim for compatibility.
// React's webpack build handles either form.

function trackEvent(name, params) {
  if (params === undefined) params = {};

  // SSR / test environments may not have `window`.
  if (typeof window === 'undefined') return;

  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development') {
    // Helpful during local dev so we can verify a fire-site without GA4 loaded.
    // Production builds elide this check via the bundler.
    // eslint-disable-next-line no-console
    console.log('[ANALYTICS]', name, params);
  }

  if (typeof window.gtag !== 'function') {
    // Consent not granted or GA4 not loaded yet — no-op.
    return;
  }

  try {
    window.gtag('event', name, params);
  } catch (_) {
    // Never let an analytics failure break the user's flow.
  }
}

module.exports = { trackEvent };
module.exports.trackEvent = trackEvent;
module.exports.default = trackEvent;
